import { set } from 'date-fns'

export type ScreeningAvailbility = {
  endTimeISO8601: Date
  startTimeISO8601: Date
}

export const constructTimeSlots = (day: Date) => {
  return [
    {
      endTimeISO8601: set(day, {
        hours: 12,
        milliseconds: 0,
        minutes: 0,
        seconds: 0,
      }),
      startTimeISO8601: set(day, {
        hours: 9,
        milliseconds: 0,
        minutes: 0,
        seconds: 0,
      }),
    },
    {
      endTimeISO8601: set(day, {
        hours: 15,
        milliseconds: 0,
        minutes: 0,
        seconds: 0,
      }),
      startTimeISO8601: set(day, {
        hours: 12,
        milliseconds: 0,
        minutes: 0,
        seconds: 0,
      }),
    },
    {
      endTimeISO8601: set(day, {
        hours: 18,
        milliseconds: 0,
        minutes: 0,
        seconds: 0,
      }),
      startTimeISO8601: set(day, {
        hours: 15,
        milliseconds: 0,
        minutes: 0,
        seconds: 0,
      }),
    },
  ]
}
